import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from "@mui/material";
  
  function InformationForm(props) {
    const { title='', open, onClose, children } = props;
  
    return (
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-delete-dialog-title"
        aria-describedby="alert-delete-dialog-description"
      >
        <DialogTitle id="alert-delete-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
            {children}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} autoFocus>Đóng</Button>
        </DialogActions>
      </Dialog>
    );
  };
  
  export default InformationForm;